import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChat = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 5a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h20l8 8v-8h4a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4zm0 4h32v24H8zm28 4H12v4h24zM12 25h14v4H12zm24-6H12v4h24z" })
});
export default SvgChat;
